import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpInterceptorService } from './services/http-interceptor.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './auth-layout/pages/login/login.component';
import { SignupComponent } from './auth-layout/pages/signup/signup.component';
import { OtpVerificationComponent } from './auth-layout/pages/otp-verification/otp-verification.component';
import { ForgotPasswordComponent } from './auth-layout/pages/forgot-password/forgot-password.component';
import { P404ErrorComponent } from './errors/404.component';
import { P419ErrorComponent } from './errors/419.component';
import { P500ErrorComponent } from './errors/500.component';

const ERROR_COMPONENTS = [
  P404ErrorComponent,
  P419ErrorComponent,
  P500ErrorComponent,
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    OtpVerificationComponent,
    ...ERROR_COMPONENTS,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    HttpClientModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      progressBar: true,
      newestOnTop: false,
      timeOut: 10000,
    }),
    NgSelectModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {provide: 'googleTagManagerId',  useValue: 'GTM-PGZ2RKX3'}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
